import React from 'react';
import styled from 'styled-components';
import { siteConfig } from '../../config/site';

const Section = styled.section`
  padding: 5rem 1rem;
  background: var(--background-light);
`;

const Inner = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1.1fr;
  gap: 3rem;
  align-items: center;
  @media (max-width: 900px) { grid-template-columns: 1fr; }
`;

const Media = styled.figure`
  margin: 0;
  aspect-ratio: 4/3;
  border-radius: 1.5rem;
  overflow: hidden;
  border: 1px solid rgba(0, 153, 0, 0.25);
  img { width: 100%; height: 100%; object-fit: cover; display: block; }
`;

const Copy = styled.div`
  color: var(--text-color);
  .tag {
    display: inline-block;
    padding: 0.35rem 0.9rem;
    border-radius: 999px;
    border: 1px solid rgba(255,255,255,0.15);
    background: rgba(0, 153, 0, 0.08);
    color: var(--primary-color);
    font-size: 0.75rem; font-weight: 700; letter-spacing: 0.08em; text-transform: uppercase;
    margin-bottom: 1rem;
  }
  h2 { font-size: clamp(1.75rem, 3.2vw, 2.5rem); margin: 0 0 1rem; span { color: var(--primary-color); } }
  p { color: var(--text-secondary); line-height: 1.75; margin: 0 0 1rem; }
  ul { list-style: none; padding: 0; margin: 1rem 0 0; }
  li {
    padding: 0.4rem 0 0.4rem 1.5rem;
    color: var(--text-color);
    position: relative;
    line-height: 1.5;
    &::before {
      content: '✓';
      color: var(--primary-color);
      font-weight: 800;
      position: absolute; left: 0; top: 0.4rem;
    }
  }
`;

const WhatIsFlashUSDT: React.FC = () => (
  <Section id="what-is-flash-usdt">
    <Inner>
      <Media>
        <img src="/img/whatis-usdt.jpg" alt="What is flash USDT — Tether (USDT) simulation software explained" />
      </Media>
      <Copy>
        <div className="tag">What is flash USDT?</div>
        <h2>Flash USDT explained in <span>plain English</span></h2>
        <p>
          Flash USDT is a simulated USDT balance that appears on supported wallets and blockchain
          explorers for a limited time — from 24 hours up to 365 days depending on your plan.
          It is <strong>not</strong> real Tether and cannot be permanently transferred, but it
          <em> looks</em> real inside crypto wallet interfaces, which is exactly what makes it
          useful for demos, testing, training, and network validation.
        </p>
        <p>
          {siteConfig.brand.name} sells licensed flash USDT software that runs on Windows,
          macOS, and Android, supports multi-chain flashing across TRC-20, ERC-20 and BEP-20,
          and delivers the license by email within minutes of payment.
        </p>
        <ul>
          <li>Appears on Trust Wallet, MetaMask, Binance, TronLink and 50+ more</li>
          <li>Multi-chain — TRC-20 (Tron), ERC-20 (Ethereum), BEP-20 (BNB Smart Chain)</li>
          <li>Tradable, swappable and transferable within the validity window</li>
          <li>Designed for demos, QA, and educational use — not real value transfer</li>
        </ul>
      </Copy>
    </Inner>
  </Section>
);

export default WhatIsFlashUSDT;
